import { ManagedUserGroup } from "types/generated";

import { ApiKeyView } from "../types";

export type ApiKeyGroupMappingEntity = Pick<
  ManagedUserGroup,
  "id" | "groupName" | "description"
> & {
  status: ApiKeyGroupMappingStatus;
};

export enum ApiKeyGroupMappingStatus {
  MAPPED = "MAPPED",
  UNMAPPED = "UNMAPPED",
}

export type CellComponentProps = {
  group: ApiKeyGroupMappingEntity;
  apiKey: ApiKeyView;
};
